// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTaskButton_root__GWdQX"};